var map = {
	"./sli-box.svg": 426,
	"./sli-calc.svg": 696,
	"./sli-car.svg": 6751,
	"./sli-case.svg": 7007,
	"./sli-document.svg": 9944,
	"./sli-driver.svg": 9169,
	"./sli-edit.svg": 1311,
	"./sli-eye.svg": 5850,
	"./sli-home.svg": 7982,
	"./sli-layer.svg": 9686,
	"./sli-material.svg": 2972,
	"./sli-quarter.svg": 8961,
	"./sli-region.svg": 179,
	"./sli-settings.svg": 7276,
	"./sli-type-of-works.svg": 6710,
	"./sli-wallet.svg": 5824,
	"./sli-year.svg": 2000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;